import React from 'react';
import { Tab } from "@mui/material";
import styled from "styled-components";

export const ScenarioBuilderStyledActionTab = styled(Tab)`
  background: #898D98 !important;
  padding: 0 20px !important;
  border-radius: 0px 26px 0px 0px !important;
`